<template>
  <div class="subscribe-component" :class="cssClass">
    <form @submit.stop.prevent="subscribe">
      <input
        class="email-input"
        type="email"
        v-validate="'email'"
        data-vv-as="email"
        name="email"
        v-model="email"
        :placeholder="placeholder || ''"
      />
      <button type="submit" class="invisible"/>
    </form>
  </div>
</template>
<script>
  export default {
    name: 'subscribe-component',
    props: [ 'cssClass', 'placeholder' ],
    data() {
      return {
        email: null,
      }
    },
    methods: {
      subscribe() {
        if (!this.email) {
          this.$toasted.error('Please enter your email address')
          return
        }
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.$http.post('email', { email: this.email })
            .then(() => {
              this.$toasted.success(`${this.email} is subscribed to our newsletter`)
              this.email = ''
            })
            .catch(res => {
              this.$toasted.error(res.body.error)
            })
          }
        })
      },
    },
  }
</script>
<style lang="scss" scoped>
  .subscribe-component.underlined {
    .email-input {
      padding: 4px;
      width: 200px;
      border: 0;
      border-bottom: 1px solid #bbb;
    }
    ::placeholder {
      opacity: 0.2;
      text-transform: uppercase;
    }
    :-ms-input-placeholder {
      opacity: 0.2;
      text-transform: uppercase;
    }
    ::-ms-input-placeholder {
      opacity: 0.2;
      text-transform: uppercase;
    }
  }
  .subscribe-component.big {
    text-align: center;
    margin-top: 30px;
    .email-input {
      padding: 10px;
      font-size: 25px;
      width: 400px;
      border: 0;
      background: $color-5;
    }
    ::placeholder {
      text-transform: uppercase;
      text-align: center;
      font-size: 20px;
      opacity: 0.4;
    }
    :-ms-input-placeholder {
      text-transform: uppercase;
      text-align: center;
      font-size: 20px;
      opacity: 0.4;
    }
    ::-ms-input-placeholder {
      text-transform: uppercase;
      text-align: center;
      font-size: 20px;
      opacity: 0.4;
    }
  }
  @media (max-width: 500px) {
    .email-input {
      max-width: calc(100% - 30px);
    }
  }
</style>

